/**
 * Track a standard Meta Pixel event when the browser Pixel has loaded.
 *
 * @param {string} eventName
 * @param {Record<string, unknown>} [parameters]
 */
function trackMetaEvent(eventName, parameters = {}) {
    if (typeof window === 'undefined' || typeof window.fbq !== 'function') return;

    window.fbq('track', eventName, parameters);
}

export default trackMetaEvent;
